export const PalettePrimaryBase = "#02457a";
export const PalettePrimaryContrastText = "#FFFFFF";
export const PaletteSecondaryBase = "#1b819a";
export const PaletteSecondaryContrastText = "#FFFFFF";
export const PaletteTertiaryBase = "#af5d00";
export const PaletteTertiaryContrastText = "#FFFFFF";
export const PaletteAccentBase = "#ffc535";
export const PaletteAccentContrastText = "#222222";
export const PaletteTextHeading = "#02457a";
export const PaletteTextPrice = "#af5d00";
export const PaletteTextLink = "#1b819a";
export const PaletteActionFocus = "#8ecef8";
export const TypographyBaseFontSize = 16;
export const TypographyBaseLineHeight = 1.5;
export const TypographyFamilyBodyFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyBodyFontWeightDefault = 400;
export const TypographyFamilyBodyFontWeightSemiBold = 600;
export const TypographyFamilyBodyFontWeightBold = 700;
export const TypographyFamilyCaptionFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyCaptionFontWeightDefault = 400;
export const TypographyFamilyCaptionFontWeightSemiBold = 600;
export const TypographyFamilyCaptionFontWeightBold = 700;
export const TypographyFamilyHeadingFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyHeadingFontWeightDefault = 700;
export const TypographyFamilyHeroFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyHeroFontWeightDefault = 700;
export const TypographyFamilyPriceFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyPriceFontWeightDefault = 700;
export const TypographyLineHeightXs = 1;
export const TypographyLineHeightS = 1.25;
export const TypographyLineHeightM = 1.5;
export const TypographyLineHeightL = 1.75;
export const TypographyBodyXsFontSize = "0.625rem";
export const TypographyBodyXsLineHeight = 1.5;
export const TypographyBodyXsLetterSpacing = "normal";
export const TypographyBodySFontSize = "0.75rem";
export const TypographyBodySLineHeight = 1.5;
export const TypographyBodySLetterSpacing = "normal";
export const TypographyBodyMFontSize = "0.875rem";
export const TypographyBodyMLineHeight = 1.5;
export const TypographyBodyMLetterSpacing = "normal";
export const TypographyBodyLFontSize = "1rem";
export const TypographyBodyLLineHeight = 1.5;
export const TypographyBodyLLetterSpacing = "normal";
export const TypographyBodyXlFontSize = "1.125rem";
export const TypographyBodyXlLineHeight = 1.5;
export const TypographyBodyXlLetterSpacing = "normal";
export const TypographyBody2xlFontSize = "1.25rem";
export const TypographyBody2xlLineHeight = 1.5;
export const TypographyBody2xlLetterSpacing = "normal";
export const TypographyHeadingXsFontSize = "0.875rem";
export const TypographyHeadingXsLineHeight = 1.5;
export const TypographyHeadingXsLetterSpacing = "normal";
export const TypographyHeadingSFontSize = "1rem";
export const TypographyHeadingSLineHeight = 1.5;
export const TypographyHeadingSLetterSpacing = "normal";
export const TypographyHeadingMFontSize = "1.125rem";
export const TypographyHeadingMLineHeight = 1.5;
export const TypographyHeadingMLetterSpacing = "normal";
export const TypographyHeadingLFontSize = "1.25rem";
export const TypographyHeadingLLineHeight = 1.25;
export const TypographyHeadingLLetterSpacing = "normal";
export const TypographyHeadingXlFontSize = "1.5rem";
export const TypographyHeadingXlLineHeight = 1.25;
export const TypographyHeadingXlLetterSpacing = "normal";
export const TypographyHeading2xlFontSize = "1.75rem";
export const TypographyHeading2xlLineHeight = 1.25;
export const TypographyHeading2xlLetterSpacing = "normal";
export const TypographyHeading3xlFontSize = "2.25rem";
export const TypographyHeading3xlLineHeight = 1.25;
export const TypographyHeading3xlLetterSpacing = "normal";
